window._ = require("lodash");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

// REMOVE WHEN laravel-echo-api-gateway is updated
//

let sessionToken = "";
if (typeof getCookie === "function") {
    sessionToken = getCookie("session_token");
}

window.axios.defaults.headers.common["Authorization"] = "Bearer " + sessionToken;
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";
import { broadcaster } from "laravel-echo-api-gateway";

let API_ID = "";
let STAGE = "";
let AUTH_URL = "";
let retries = 0;

if (process.env.MIX_ENV === "production") {
  API_ID = process.env.MIX_LARAVEL_ECHO_API_GATEWAY_API_ID_PRODUCTION;
  STAGE = process.env.MIX_LARAVEL_ECHO_STAGE_PRODUCTION;
  AUTH_URL = "https://api.nouri.ai";
} else if (process.env.MIX_ENV === "staging") {
  API_ID = process.env.MIX_LARAVEL_ECHO_API_GATEWAY_API_ID_STAGING;
  STAGE = process.env.MIX_LARAVEL_ECHO_STAGE_STAGING;
  AUTH_URL = "https://stage-api.nouri.ai";
} else {
  API_ID = process.env.MIX_LARAVEL_ECHO_API_GATEWAY_API_ID_STAGING;
  STAGE = process.env.MIX_LARAVEL_ECHO_STAGE_STAGING;
  AUTH_URL = "https://api.nouri.test";
}

websocketConnect();

function websocketConnect() {
  console.info(
    "Connecting to: wss://" +
      API_ID +
      ".execute-api.us-west-2.amazonaws.com/" +
      STAGE
  );

  window.Echo = null;

  window.Echo = new Echo({
    broadcaster,
    host: "wss://" + API_ID + ".execute-api.us-west-2.amazonaws.com/" + STAGE,
    authEndpoint: AUTH_URL + "/broadcasting/auth",
    bearerToken: sessionToken,
    enabledTransports: ["ws", "wss"],
  });

  window.dispatchEvent(new CustomEvent("websocket-connected"));

  console.info("Connected");
  window.Echo.connector.socket.websocket.onclose = () => {
    console.info("Disconnected. Attempting to reconnect now.");

    // Count retries
    retries++;

    // If retried > 5, slow down to every 10 seconds
    if (retries > 5) {
      setTimeout(function () {
        websocketConnect();
      }, 10000);
    } else {
      websocketConnect();
    }
  };
}
